import esp from "../../misc/lang/esp";
const optionsReducer = (
  state = { lang: { code: "esp", data: esp } },
  action
) => {
  switch (action.type) {
    case "SET_LANGUAGE": {
      const newState = { ...state, lang: action.lang };
      return newState;
    }
    default:
      return state;
  }
};

export default optionsReducer;
